import React, { useEffect, useState } from 'react';
import {
  Box, Flex, Heading, SimpleGrid, Stat, StatLabel, StatNumber,
  StatHelpText, Icon, Text, Spinner, Alert, AlertIcon,
} from '@chakra-ui/react';
import { FiShield, FiCheckCircle, FiKey, FiLogIn, FiUserPlus } from 'react-icons/fi';

const StatCard = ({ label, value, helpText, icon, color }) => (
  <Box bg="white" rounded="xl" shadow="sm" p={6} borderTop="4px solid" borderColor={color}>
    <Flex justify="space-between" align="flex-start">
      <Stat>
        <StatLabel color="gray.500" fontSize="sm">{label}</StatLabel>
        <StatNumber fontSize="3xl" fontWeight="bold" color="gray.800">{value ?? '—'}</StatNumber>
        {helpText && <StatHelpText color="gray.400">{helpText}</StatHelpText>}
      </Stat>
      <Box bg={`${color.split('.')[0]}.50`} p={3} rounded="lg">
        <Icon as={icon} boxSize={6} color={color} />
      </Box>
    </Flex>
  </Box>
);

export default function Dashboard({ token, apiBase }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`${apiBase}/api/dashboard/`, {
      headers: { Authorization: `Token ${token}` },
    })
      .then(r => r.json())
      .then(setStats)
      .catch(() => setError('Failed to load stats'))
      .finally(() => setLoading(false));
  }, [apiBase, token]);

  return (
    <Box p={8}>
      <Heading size="lg" mb={2} color="gray.800">Dashboard</Heading>
      <Text color="gray.500" mb={8}>Microsoft Entra SSO service overview</Text>

      {loading && <Spinner size="xl" color="blue.500" />}
      {error && <Alert status="error"><AlertIcon />{error}</Alert>}

      {stats && (
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
          <StatCard
            label="Total Tenants"
            value={stats.total_tenants}
            helpText="Configured tenants"
            icon={FiShield}
            color="blue.500"
          />
          <StatCard
            label="Enabled Tenants"
            value={stats.enabled_tenants}
            helpText="SSO active"
            icon={FiCheckCircle}
            color="green.500"
          />
          <StatCard
            label="Active API Keys"
            value={stats.total_api_keys}
            helpText="Service keys"
            icon={FiKey}
            color="purple.500"
          />
          <StatCard
            label="SSO Logins"
            value={stats.recent_logins}
            helpText="All time"
            icon={FiLogIn}
            color="teal.500"
          />
          <StatCard
            label="Auto-Provisioned"
            value={stats.recent_provisions}
            helpText="New accounts via SSO"
            icon={FiUserPlus}
            color="orange.500"
          />
        </SimpleGrid>
      )}
    </Box>
  );
}
